import { CurrencyIcon } from '@components'
import cn from 'classnames'
import type { FxRate } from 'mmfintech-backend-api/types'

interface Props {
  node: FxRate
}

function ExchangeButton({ node }: Props) {
  const { fromCurrency, toCurrency, rate, change } = node
  const { changePercentage } = change || {}

  return (
    <div className='exchange-button-wrap'>
      <div className='left'>
        <CurrencyIcon currency={fromCurrency} size='4rem' />
        <div className='rate'>
          <span className='currency'>
            {fromCurrency}/{toCurrency}
          </span>
          <span className='price'>{rate}</span>
        </div>
      </div>
      <span className={cn('change', { positive: changePercentage > 0, negative: changePercentage < 0 })}>
        {changePercentage}%
      </span>
    </div>
  )
}

export default ExchangeButton
